import { createBannerVideoController } from "./banner-video";
gsap.registerPlugin(ScrollTrigger);
// yieldStep lets the caller split this init into short tasks (Total Blocking Time).
export async function swiperInit(yieldStep = () => Promise.resolve()) {
	function getSlidesPerGroup(slidesSizesGrid, visibleSlidesIndexes) {
		const totalSlide = slidesSizesGrid.length;
		const visibleSlide = visibleSlidesIndexes?.length ?? 1;

		let slidesPerGroup = visibleSlide;

		if (totalSlide <= visibleSlide) {
			slidesPerGroup = null;
		}
		return slidesPerGroup;
	}
	function triggerLozadNextSlideImage(swiper) {
		const nextSlide = swiper.slides[swiper.activeIndex + 1];
		if (nextSlide) {
			const nextImage = nextSlide.querySelectorAll("img");
			const loader = window.lazyLoader;
			if (nextImage && loader && typeof loader.triggerLoad === "function") {
				nextImage.forEach((img) => {
					loader.triggerLoad(img);
				});
			} else {
				throw new Error("Lozad is not defined");
			}
		}
	}
	function autoSetSlidesPerGroup(swiper) {
		if (!swiper.pagination.el) return;
		const { visibleSlidesIndexes, slidesSizesGrid } = swiper;
		const slidesPerGroup = getSlidesPerGroup(
			slidesSizesGrid,
			visibleSlidesIndexes
		);
		if (
			slidesPerGroup != null &&
			slidesPerGroup > 0 &&
			slidesPerGroup !== swiper.params.slidesPerGroup
		) {
			swiper.params.slidesPerGroup = slidesPerGroup;
			swiper.update();
		}
	}


	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				slidesPerView: 8,
			},

		},
	});



	var slideNumberVerticalSwiper = new Swiper(".slide-number-vertical .swiper", {
		loop: true,
		speed: 900,
		spaceBetween: 20,
		autoplay: {
			delay: 200000,
			disableOnInteraction: false,
		},
		direction: "vertical",
		breakpoints: {
			320: {
				slidesPerView: 1,
			},

		},
	});


	// 1. Initialize Swiper
	// Detect single slide to avoid Swiper loop issues (loop needs 2+ slides)
	const primaryBannerSlides = document.querySelectorAll(".primary-banner .swiper .swiper-slide");
	const isSingleSlide = primaryBannerSlides.length <= 1;

	window.primarySwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: false,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: !isSingleSlide,
		init: false,
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},
		pagination: {
			el: ".primary-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}" data-index="${index}"></span>`;
			},
		},
	});

	// 2. Global Variables
	let progressInterval = null;
	let timer = null;
	let isPaused = false; // NEW: Track manual pause state
	const slideTimeout = 4000;
	const bannerVideos = createBannerVideoController(document.querySelector(".primary-banner"), {
		isPaused: () => isPaused,
		startDelay: 1500,
		onReady: () => {
			const slide = primarySwiper.slides[primarySwiper.activeIndex];
			const video = bannerVideos.getVideo(slide);
			if (!video || video.paused) handleVideoPlayback(slide);
		},
		onPause: () => {
			document.querySelectorAll(".primary-banner-video").forEach(video => video.pause());
			if (progressInterval) clearInterval(progressInterval);
			if (timer) clearTimeout(timer);
		},
	});


	// GLOBAL
	window.triggerFadeUp = function (slide) {
		if (!window.introFinished) return;

		if (!slide) return;

		const texts = slide.querySelectorAll(".text-fd-up");

		texts.forEach((el) => {
			el.classList.remove("is-visible");

			// force reflow
			void el.offsetWidth;

			el.classList.add("is-visible");
		});
	};


	// 3. Progress Track Function
	function startProgressTrack() {
		if (progressInterval) clearInterval(progressInterval);
		if (isPaused) return; // Don't start animation if paused

		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (!progressTrack) return;

		const intervalStep = 20;
		// Get current width to allow resuming from same spot if desired, 
		// otherwise it defaults to 0 on new slides.
		let progress = parseFloat(progressTrack.style.width) || 0;

		progressInterval = setInterval(() => {
			if (!isPaused) {
				progress += (intervalStep / slideTimeout) * 100;
				if (progress >= 100) {
					clearInterval(progressInterval);
					progressTrack.style.width = "100%";
				} else {
					progressTrack.style.width = `${progress}%`;
				}
			}
		}, intervalStep);
	}

	function resetProgressTrack() {
		if (progressInterval) {
			clearInterval(progressInterval);
			progressInterval = null;
		}
		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (progressTrack) {
			progressTrack.style.width = "0%";
		}
	}

	// 4. Video & Timer Handling
	function handleVideoPlayback(slide) {
		if (!slide) return;
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		if (!isPaused) {
			resetProgressTrack();
		} else if (progressInterval) {
			clearInterval(progressInterval);
		}

		// Stop all videos first
		const allVideos = document.querySelectorAll(".primary-banner-video");
		allVideos.forEach((video) => {
			video.pause();
		});

		const videoElement = bannerVideos.getVideo(slide);

		if (videoElement) {
			videoElement.muted = true;           // force muted via JS too (iOS quirk)
			videoElement.setAttribute('playsinline', '');
			videoElement.setAttribute('webkit-playsinline', '');

			// Single slide with video: loop the video instead of trying to slideNext
			if (isSingleSlide) {
				videoElement.loop = true;
			} else {
				videoElement.loop = false;
			}

			if (bannerVideos.prepare(videoElement, slide)) {
				startProgressTrack();

				const playPromise = videoElement.play();
				if (playPromise !== undefined) {
					playPromise.catch((error) => {
						console.warn('Autoplay blocked:', error);
						// Fallback: treat it like an image slide
						if (!isSingleSlide && error.name !== "AbortError" &&
							videoElement === bannerVideos.getVideo(slide) &&
							slide === primarySwiper.slides[primarySwiper.activeIndex] && bannerVideos.canStart(slide)) {
							timer = setTimeout(() => {
								primarySwiper.slideNext();
							}, slideTimeout);
						}
					});
				}

				// Multiple slides: advance to next slide when video ends
				if (!isSingleSlide) {
					videoElement.removeEventListener('ended', videoElement._onEnded);
					videoElement._onEnded = function () {
						if (bannerVideos.canStart(slide) && slide === primarySwiper.slides[primarySwiper.activeIndex]) {
							primarySwiper.slideNext();
						}
					};
					videoElement.addEventListener('ended', videoElement._onEnded);
				}
			}

		} else {
			// Handle Image Slides
			if (bannerVideos.canStart(slide)) {
				startProgressTrack();
				if (!isSingleSlide) {
					timer = setTimeout(() => {
						primarySwiper.slideNext();
					}, slideTimeout);
				}
			}
		}
	}

	// 5. Swiper Event Listeners
	primarySwiper.on("slideChangeTransitionEnd", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	primarySwiper.on("slideChangeTransitionStart", function () {
		if (!isPaused) {
			resetProgressTrack();
		}
	});

	primarySwiper.on("init", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	// Pause/resume the viewport-selected video, including keyboard activation.
	const pauseTrackBtn = document.querySelector(".pause-track");
	if (pauseTrackBtn) {
		pauseTrackBtn.addEventListener("click", function () {
			isPaused = !isPaused;
			this.classList.toggle("paused", isPaused);
			this.setAttribute("aria-pressed", String(isPaused));
			this.setAttribute("aria-label", isPaused ? "Play banner video" : "Pause banner video");
			handleVideoPlayback(primarySwiper.slides[primarySwiper.activeIndex]);
		});
		pauseTrackBtn.addEventListener("keydown", function (event) {
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				this.click();
			}
		});
	}

	window.pausePrimaryBannerVideo = function () {
		document.querySelectorAll(".primary-banner-video").forEach(video => video.pause());
		if (progressInterval) clearInterval(progressInterval);
		if (timer) clearTimeout(timer);
	};
	window.resumePrimaryBannerVideo = function () {
		handleVideoPlayback(primarySwiper.slides[primarySwiper.activeIndex]);
	};

	const primaryBannerVideo = document.querySelectorAll(".primary-banner-video");
	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("click", function () {
			if (pauseTrackBtn) pauseTrackBtn.click();
		});
	});

	// 8. Run Init
	primarySwiper.init();
	await yieldStep();

	window.initSwiper = [];

	$(".init-swiper .swiper").each(function (index) {
		const $this = $(this);

		const isLoop = $this.hasClass("is-loop");
		const isTriggerLoadedNext = $this.hasClass("trigger-loaded-next");
		const isCenter = $this.hasClass("is-center-slide");

		let time = parseInt($this.attr("data-time"), 10);
		if (isNaN(time)) time = 5000;

		// Pagination type
		let paginationType = "bullets";
		if ($this.hasClass("fraction")) {
			paginationType = "fraction";
		} else if ($this.hasClass("progress")) {
			paginationType = "progressbar";
		}

		// Unique classes
		$this.addClass("swiper-init-" + index);
		$this.parents(".init-swiper").find(".prev").addClass("prev-nav-" + index);
		$this.parents(".init-swiper").find(".next").addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		// Base options
		const options = {
			observer: true,
			observeParents: true,
			rewind: !isLoop,
			speed: 1205,
			watchSlidesProgress: true,
			slidesPerView: "auto",

			lazy: {
				loadPrevNext: true,
			},

			loop: isLoop,

			autoplay: {
				delay: time,
				pauseOnMouseEnter: true,
			},

			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},

			pagination: {
				el: ".pagination-inst-" + index,
				type: paginationType,
				clickable: true,
				dynamicMainBullets: 1,
			},

			// ✅ Center mode
			centeredSlides: isCenter,

			on: {
				beforeInit: function () {
					window.initSwiper.push(this);
				},

				init: function () {
					// Fix duplicate fancybox in loop mode
					if (isLoop) {
						window.lozadInit?.();

						$(this.el)
							.find(".swiper-slide-duplicate a[data-fancybox]")
							.removeAttr("data-fancybox");
					}

					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},

				slideChange: function () {
					// Pause videos when slide changes
					if ($this.hasClass("slide-has-video")) {
						const $videos = $this.find("video");
						if ($videos.length) {
							$videos[0].pause();
						}

						$this.find(".swiper-slide").removeClass("play-video");
						$this.find(".play-btn").removeClass("active");
					}

					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},

				resize: function (swiper) {
					const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
						(acc, curr) => acc + curr,
						0
					);

					swiper.el.classList.toggle(
						"center-slide-active",
						totalSlidesWidth < swiper.size
					);

					autoSetSlidesPerGroup(swiper);
				},
			},
		};

		// ✅ Improve center behavior
		if (isCenter) {
			options.centeredSlidesBounds = true;
		}

		// ✅ Initial slide support
		const initialSlide = parseInt($this.attr("data-initial"), 10);
		if (!isNaN(initialSlide)) {
			options.initialSlide = initialSlide;
		}

		// ✅ Special case: continuous autoplay
		if (time === 0) {
			options.autoplay = {
				delay: 0,
				disableOnInteraction: true,
				pauseOnMouseEnter: false,
			};

			options.loop = true;
			options.speed = 1800;

			delete options.navigation;
		}

		// Init Swiper
		new Swiper(".swiper-init-" + index, options);
	});


	await yieldStep();
	var gridSwiper = new Swiper(".branding-grid-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			490: {
				slidesPerView: 3,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			768: {
				slidesPerView: 4,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1400: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},
		navigation: {
			nextEl: ".partner-grid-swiper .next",
			prevEl: ".partner-grid-swiper .prev",
		},
	});
	var aboutGridSwiper = new Swiper(".about-grid-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		watchSlidesProgress: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			420: {
				slidesPerView: 3,

			},

			768: {
				slidesPerView: 4,

			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,

			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 40,

			},
		},

	});
	var aboutGridSwiper = new Swiper(".about-grid-swiper-2 .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		watchSlidesProgress: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			420: {
				slidesPerView: 3,

			},

			768: {
				slidesPerView: 4,

			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,

			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 40,

			},
		},

	});


	var certProductSwiper = new Swiper(".cert-product-swiper .swiper", {
		spaceBetween: 0,
		slidesPerView: "auto",
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		loop: true,
		speed: 2000,
		spaceBetween: 0,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			200: {
				slidesPerView: "auto",
			},

		},
	});

	window.certProductSwiper = certProductSwiper;




	await yieldStep();
	// Standard timeline slider shared by the homepage and About page.
	document.querySelectorAll(".home-develope .swiper").forEach((element) => {
		const section = element.closest(".home-develope");
		const swiper = new Swiper(element, {
			spaceBetween: 20,
			slidesPerView: 1.5,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			speed: 700,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			resizeObserver: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			mousewheel: false,
			navigation: {
				nextEl: section.querySelector(".next"),
				prevEl: section.querySelector(".prev"),
			},
			lazy: {
				loadPrevNext: true,
			},
			breakpoints: {
				1200: { slidesPerView: "auto", spaceBetween: 40 },
				1280: { slidesPerView: "auto", spaceBetween: 80 },
			},
		});
		// Wait until the timeline itself is visible, including inside fullpage's scroller.
		swiper.autoplay.stop();
		const autoplayObserver = new IntersectionObserver(([entry]) => {
			if (swiper.destroyed) return;
			if (entry.isIntersecting) {
				if (!swiper.autoplay.running) swiper.autoplay.start();
			} else {
				swiper.autoplay.stop();
			}
		});
		autoplayObserver.observe(element);
		swiper.on("destroy", () => autoplayObserver.disconnect());
		window.homeDevelopeSwiper = swiper;
	});

	const groupViewMore = $('.view-more-group');
	const btnToggleViewMore = $('.btn-view-more-toggle');

	if (btnToggleViewMore !== null) {
		btnToggleViewMore.on('click', function () {
			groupViewMore.stop(true, true).slideToggle(800, function () {
				// Runs after slideToggle animation completes
				ScrollTrigger.refresh();
			});
			$(this).toggleClass('is-close');
		});
	}



	await yieldStep();
	// ---------- THUMB SLIDER ----------
	var homeThumb = new Swiper(".home-thumb .swiper", {
		spaceBetween: 0,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			476: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	});

	window.homeThumb = homeThumb;


	// ---------- MAIN SLIDER ----------
	var homeMain = new Swiper(".home-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		thumbs: {
			swiper: homeThumb,
		},
	});

	window.homeMain = homeMain;



	var productThumb = new Swiper(".product-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 4,
				spaceBetween: 10,
				direction: "horizontal",
			},
			476: {
				slidesPerView: 4,
				direction: "horizontal",
			},
			768: {
				slidesPerView: 6,
				direction: "horizontal",
			},
			1024: {
				slidesPerView: 3,
				direction: "horizontal",
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: "vertical",
			},
		},
		speed: 500,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
	});
	window.productThumb = productThumb;
	var productMain = new Swiper(".product-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".product-detail  .next-nav",
			prevEl: ".product-detail  .prev-nav",
		},
		thumbs: {
			swiper: productThumb,
		},
	});
	window.productMain = productMain;


	// ---------- HOVER THUMB → CHANGE MAIN ----------
	function bindThumbHover() {
		document
			.querySelectorAll(".home-thumb .swiper-slide")
			.forEach((slide, index) => {

				slide.addEventListener("mouseenter", () => {
					homeMain.autoplay.stop();
					homeMain.slideTo(index);
				});

				slide.addEventListener("mouseleave", () => {
					homeMain.autoplay.start();
				});
			});
	}

	// bind after Swiper is ready
	homeThumb.on("init", bindThumbHover);
	bindThumbHover();


	// ---------- KEEP THUMB IN SYNC WHEN MAIN CHANGES ----------
	homeMain.on("slideChange", () => {
		homeThumb.slideTo(homeMain.activeIndex);
	});



}


